import { TertiaryButton } from '@monthio/design-system'
import { COLORS } from '@monthio/react-components'
import styled, { css } from 'styled-components'

const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 20px;
`
const SelectButton = styled(TertiaryButton)<{
	$isSelected: boolean
}>`
	${(p) =>
		p.$isSelected &&
		css`
			outline: 2px solid ${COLORS.PRIMARY_DARKER};
		`}
`

export function ButtonSelect<TValue>({
	currentValue,
	values,
	onChange,
}: {
	currentValue?: TValue
	values: { value: TValue; displayValue: string }[]
	onChange: (value: TValue) => void
}): JSX.Element {
	return (
		<Container>
			{values.map(({ value, displayValue }) => (
				<SelectButton
					type="button"
					key={value?.toString() || 'empty'}
					onClick={() => onChange(value)}
					$isSelected={value === currentValue}
				>
					{displayValue}
				</SelectButton>
			))}
		</Container>
	)
}
